import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import 'primeflex/primeflex.css';
import './index.css';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import 'primeicons/primeicons.css';

const root = ReactDOM.createRoot(document.getElementById('root') as Element);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
